export default {
    data: () => ({
        mobile: window.innerWidth <= 700
    }),

    created() {
        // @see https://developers.google.com/web/updates/2016/06/passive-event-listeners
        // @see https://iamakulov.com/notes/resize-scroll/
        addEventListener('resize', () => {
            this.mobile = innerWidth <= 700;
        }, {
            passive: true
        });
    }
};
